import React from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Multi1 from "../../../images/modulo14/multi1.png";
import Multi2 from "../../../images/modulo14/multi2.png";

const Actividad1 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[2];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[3].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[3].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[1].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[1].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-4 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-9 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>Un país multilingüe pero desigual</strong>
            </h4>
            <p className="mt-1">
              El Perú es un país multilingüe pues se hablan en él muchas
              lenguas. Pero, como hemos visto ya, hay una lengua que es
              percibida como más valiosa que las otras.
            </p>
            <p>
              El castellano es considerada la lengua más{" "}
              <strong>prestigiosa</strong>. Además, es la lengua en que se
              ofrecen la mayor parte de servicios públicos (educación, salud,
              justicia).
            </p>
          </div>
          <div className="col-md-3">
            <img
              src={Multi2}
              className="bg-white img-fluid rounded"
              alt="Variedad Castellano"
            />
          </div>
          <div className="col-md-3">
            <img
              src={Multi1}
              className="bg-white img-fluid rounded"
              alt="Variedad Castellano"
            />
          </div>
          <div className="col-md-9 p-md-5 p-0">
            <p>
              Esto es un problema para muchos peruanos que hablan poco o nada de
              castellano. Lo justo sería que cada persona pueda acceder a{" "}
              <strong>servicios en su lengua nativa</strong>, además del
              castellano.
            </p>
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Pida que lean el título del texto y observen las
            imágenes. Pregunte: ¿qué ven en ella? ¿En qué se diferencian ambas
            imágenes? Refuerce la idea de la importancia de mantener el
            bilingüismo en diferentes espacios y servicios. (La palabra “najáwe”
            significa dolor en awajún). Luego lean en voz alta, por turnos el
            texto titulado Un país multilingüe pero desigual.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
